export const initialise = (): void => {
    const isDesktop = (): boolean => window.innerWidth >= 990;

    if (!isDesktop()) {
        return;
    }

    const secondLevelItems = document.querySelectorAll<HTMLLIElement>('.navLevel-1 .links li.hasChildren');
    const allThirdLevelMenus = document.querySelectorAll<HTMLUListElement>('.navLevel-2');
    const navLevel1Container = document.querySelectorAll<HTMLElement>('.navLevel-1');

    let debounceTimer: ReturnType<typeof setTimeout>;

    secondLevelItems.forEach((item) => {
        item.addEventListener('mouseenter', () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                const triggerBtn = item.querySelector('.attrax-child-nav-trigger');
                const targetId = triggerBtn ? triggerBtn.getAttribute('aria-controls') : null;

                if (targetId) {
                    allThirdLevelMenus.forEach(menu => menu.classList.remove('open'));

                    const targetMenu = document.getElementById(targetId);
                    if (targetMenu) {
                        targetMenu.classList.add('open');
                    }
                }
            }, 150);
        });
    });

    if (navLevel1Container.length) {
        navLevel1Container.forEach(container => {
            container.addEventListener('mouseleave', () => {
                clearTimeout(debounceTimer);
                allThirdLevelMenus.forEach(menu => menu.classList.remove('open'));
            });
        });
    }

    window.addEventListener('resize', () => {
        if (!isDesktop()) {
            allThirdLevelMenus.forEach(menu => menu.classList.remove('open'));
        }
    });
};